import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';
import { enableAkitaProdMode } from '@datorama/akita';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
  enableAkitaProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    applicationProviders: [
      provideZoneChangeDetection({ eventCoalescing: true }),
      // CDK 21 defaults overlays (dialogs, menus...) to the native Popover API (top layer),
      // which always renders above regular z-index-stacked elements (e.g. tippy tooltips). Revert to classic z-index stacking.
      { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },
    ],
  })
  .then(_ref => {
    console.log(`✅ Application started [${environment.production ? 'prod' : 'dev'} mode]\n\n\n`);
    /* keep */ /*console.log(_ref);*/
  }
  )
  .catch(err => console.error(err));
